import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'components/ReactRouterDomLocalized';
import {t} from 'l10n';

import {toggleMemberVirtualGiftHidden} from 'reducers/member';

import 'sass/virtualgift/VirtualGiftActions.scss';
import paths from 'paths';

function VirtualGiftActions({virtualGift, className = 'virtual-gift-actions', toggleMemberVirtualGiftHidden}) {
    let {sender} = virtualGift;

    let onHideClick = function(event) {
        event.stopPropagation();
        toggleMemberVirtualGiftHidden({id: virtualGift.id})
    };

    return (
        <div className={className}>
            {sender && <Link to={{pathname: paths.virtualGifts.path, search: '?r='+encodeURIComponent(sender.nick)}} className="icon icon-return-favour" title={t('Return the favor')} />}
            {sender && <a href={'/membre/conversation/'+encodeURIComponent(sender.id)} className="icon icon-send-message" title={t('Send a message')}/>}
            <div className={'icon icon-hide' + (virtualGift.hidden ? ' active' : '')} onClick={onHideClick} title={t('Hide')}/>
        </div>
    )
}

export default connect(
    null,
    {
        toggleMemberVirtualGiftHidden: toggleMemberVirtualGiftHidden
    }
)(VirtualGiftActions);


// WEBPACK FOOTER //
// ./src/components/virtualgift/VirtualGiftActions.js